import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loadPromise?: Promise<void>;

  load(): Promise<void> {
    // Karma runs load the real Maps SDK over the network and cause flaky script errors in unrelated specs.
    if (typeof (window as any).__karma__ !== 'undefined') {
      if (!this.loadPromise) {
        (window as any).google = (window as any).google ?? { maps: {} };
        (window as any).google.maps = (window as any).google.maps ?? {};
        (window as any).google.maps.places = (window as any).google.maps.places ?? {};
        this.loadPromise = Promise.resolve();
      }
      return this.loadPromise;
    }

    if (window['google']?.maps?.places) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js' + '?key=AIzaSyDzQ56huj4Bbw7e2x9yG4yvOpyB6QV3Qko' + '&libraries=places' + '&language=en';
      script.async = true;
      script.defer = true;

      script.onload = () => resolve();
      script.onerror = reject;

      document.head.appendChild(script);
    });

    return this.loadPromise;
  }
}
